import { Component, inject } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog';
import { CustomInputFieldComponent } from '../../components/custom-input-field/custom-input-field.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-schema-array-field-editor-dialog',
  templateUrl: './schema-array-field-editor-dialog.component.html',
  styleUrls: ['./schema-array-field-editor-dialog.component.scss'],
  imports: [
    CustomInputFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    MatIconButton,
    MatIcon,
    MatButton,
    MatDialogClose,
  ],
})
export class SchemaArrayFieldEditorDialogComponent {
  private dialogRef =
    inject<MatDialogRef<SchemaArrayFieldEditorDialogComponent>>(MatDialogRef);
  private fb = inject(FormBuilder);

  data = inject<{
    schemaRow: Record<string, unknown>;
    fieldName: string;
  }>(MAT_DIALOG_DATA);

  readonly array = new FormArray<FormControl<string | null>>([]);

  constructor() {
    const data = this.data;

    const { schemaRow, fieldName } = data;

    const elements = schemaRow[fieldName] as string[];
    elements.forEach(this.addElement);
  }

  addElement = (str = '') => {
    const control = new FormControl<string | null>(str);
    this.array.push(control);
  };

  removeElement(index: number) {
    if (index < 0 || index >= this.array.length) {
      return;
    }

    this.array.removeAt(index);
  }

  submit() {
    const elements = this.array.controls.map((control) => control.value);
    this.dialogRef.close(elements);
  }
}
